import { Player } from 'shaka-player';

import {
  getCredentialParamsString,
  PartCredentialType,
} from './part-credentials';

export const getDashPlaylistWithCredentials = (
  playlistUrl: string,
  partCredentials: Partial<PartCredentialType>
): string => {
  return playlistUrl.replace(
    /.mpd/,
    `.mpd?${getCredentialParamsString(partCredentials)}`
  );
};

type DashInstanceArgType = {
  manifestUrl: string;
  videoElement: HTMLVideoElement | null | undefined;
  partCredentials: PartCredentialType;
  beforeLoad: (el: HTMLVideoElement) => void;
  onLoadError: (error: Error) => void;
};

export function createDashInstance({
  manifestUrl,
  videoElement,
  partCredentials,
  beforeLoad = () => undefined,
  onLoadError = () => undefined,
}: DashInstanceArgType): Player {
  const player = new Player(videoElement);
  const queryParameters = `?${getCredentialParamsString(partCredentials)}`;

  player.configure({
    streaming: {
      bufferingGoal: 120, // arbitrary
    },
  });

  // Intercept requests to segments and append the query parameters to authorize the request.
  player.getNetworkingEngine().registerRequestFilter((type, request) => {
    request.uris[0] = (request.uris[0] + queryParameters).replace(/\?+/, '?'); // // replace a sequence of ? with a single char
  });

  beforeLoad(player);

  // remove credentials from URL, if any, before loading the player.
  // The new ones will be applied by shaka-player thanks to callback passed
  // to registerRequestFilter.
  player
    .load(removeQueryParams(manifestUrl, Object.keys(partCredentials)))
    .catch(onLoadError);

  return player;

  function removeQueryParams(url: string, params: string[]): string {
    let newUrl = url;

    params.forEach(key => {
      newUrl = newUrl.replace(new RegExp(`${key}=(.*)?&?`, 'g'), '');
    });

    return newUrl;
  }
}

export function isDashSupported(): boolean {
  return isWebmSupported();
}

export function isWebmSupported(): boolean {
  // safari 14 supports MSE but not dash
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const isNotSafari = !window.safari;

  return (
    isNotSafari &&
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    typeof (window.MediaSource || window.WebKitMediaSource) === 'function'
  );
}
